import { render, staticRenderFns } from "./IntroOdekakePointPanel.vue?vue&type=template&id=03635aaa&"
import script from "./IntroOdekakePointPanel.vue?vue&type=script&lang=ts&"
export * from "./IntroOdekakePointPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports